class InvziMegaTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-invzi-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-invzi-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('focus', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('click', () => this.activate(tab.dataset.invziTab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
    });
  }

  activate(category) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.invziTab === category;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.invziPanel === category;

      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  }

  handleKeydown(event, currentIndex) {
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();

    let nextIndex = currentIndex;

    if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.tabs[nextIndex].focus();
  }
}

if (!customElements.get('invzi-mega-tabs')) {
  customElements.define('invzi-mega-tabs', InvziMegaTabs);
}
